import Transactions from './transactions';
import Banks from './banks';
import Agents from './agents';
import Logout from './logout';

const menuItems = {
  items: [Transactions, Banks, Agents, Logout]
};

export default menuItems;
